import './App.css';
import { Route, Routes } from 'react-router-dom';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Head from './components/Head';
import Rooms from './pages/Rooms'
import Experiences from './pages/Experiences';
import Spa from './pages/Spa';
import Treatment from './pages/Treatment';
import Policies from './pages/Policies'
import Booking from './pages/Booking'

function App() {
  return (
    <>
      <Head />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/spa" element={<Spa />} />
        <Route path="/treatment" element={<Treatment />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/blackrock" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
